export const REFERENCER_EVENT_TYPE = 'Referencer';

export const REFERENCER_COMPLETE_RECOMMENDATION_NOTIFY_NOW =
  'referencer_complete-recommendation_notify-now';

export const REFERENCER_COMPLETE_RECOMMENDATION_NOTIFY_LATER =
  'referencer_complete-recommendation_notify-later';

/* Candidate events */
export const CANDIDATE_EVENT_TYPE = 'Candidate';

export const CANDIDATE_ACCEPT_RECOMMENDATION_COMPANY_EVENT =
  'candidate_recommendation-company-list_accept';

export const CANDIDATE_DECLINE_RECOMMENDATION_COMPANY_EVENT =
  'candidate_recommendation-company-list_decline';

export const CANDIDATE_GAMIFICATION_ONBOARDING_SUBMIT_COMPANIES =
  'candidate_gamification-onboarding_submit-companies';

export const CANDIDATE_GAMIFICATION_ONBOARDING_SUBMIT_JOB_TYPES_TITLES =
  'candidate_gamification-onboarding_submit-job-types-titles';

export const CANDIDATE_GAMIFICATION_ONBOARDING_SUBMIT_JOB_LOCATIONS_TEAMSIZES =
  'candidate_gamification-onboarding_submit-job-locations-teamsizes';

export const CANDIDATE_INVITATION_TOAST_CLICK = 'candidate_invitation-toast_click';

export const CANDIDATE_PENDING_SUBMISSION_TOAST_CLICK = 'candidate_pending-submission-toast_click';

export const CANDIDATE_ADD_REFERENCE_CLICK = 'candidate_add-reference_click';

export const CANDIDATE_ADD_REFERENCE_SAVE = 'candidate_add-reference_submit';

export const CANDIDATE_PREFERENCES_EDIT_COMPANIES = 'candidate_preferences_edit-companies';

export const CANDIDATE_PREFERENCES_EDIT_JOB_TYPES_TITLES =
  'candidate_preferences_edit-job-types-titles';

export const CANDIDATE_PREFERENCES_EDIT_JOB_LOCATIONS_TEAMSIZES =
  'candidate_preferences_edit-job-locations-teamsizes';

export const CANDIDATE_PUBLIC_PROFILE_SETTINGS_SET_PUBLIC =
  'candidate_public-profile-settings_set-public';

export const CANDIDATE_PUBLIC_PROFILE_SETTINGS_UPDATE_PUBLIC_REFERENCES =
  'candidate_public-profile-settings_update-public-references';

export const CANDIDATE_PUBLIC_PROFILE_SETTINGS_COPY_PUBLIC_URL =
  'candidate_public-profile-settings_copy-public-url';

export const CANDIDATE_PUBLIC_PROFILE_SETTINGS_PREVIEW_PROFILE =
  'candidate_public-profile-settings_preview-profile';

/* Hirer events */
export const HIRER_EVENT_TYPE = 'Hirer';

export const HIRER_ANALYTICS_DASHBOARD_VIEW_USAGE_STATS =
  'hirer_analytics_dashboard_view-usage-stats';
export const HIRER_ANALYTICS_DASHBOARD_VIEW_DATA_ANALYSIS =
  'hirer_analytics_dashboard_view-data-analysis';
export const HIRER_ANALYTICS_DASHBOARD_VIEW_CSV_EXPORT =
  'hirer_analytics_dashboard_view-csv-export';
export const HIRER_USAGE_STATS_FILTER_CUSTOM_DATE = 'hirer_usage-stats_filter-custom-date';
export const HIRER_USAGE_STATS_FILTER_CANDIDATE_REFERENCER_ENGAGEMENT =
  'hirer_usage-stats_filter-candidate-referencer-engagement';
export const HIRER_USAGE_STATS_FILTER_USER_ENGAGEMENT = 'Hirer_usage-stats_filter-user-engagement';
export const HIRER_DATA_ANALYSIS_FILTER = 'hirer_data-analysis_filter';
export const HIRER_DATA_ANALYSIS_FILTER_BEHAVIOR_PROFILES =
  'hirer_data-analysis_filter-behavior-profiles';
export const HIRER_DATA_ANALYSIS_FILTER_SCORE = 'hirer_data-analysis_filter-score';
export const HIRER_CSV_EXPORT_DOWNLOAD = 'hirer_csv-export_download';
export const HIRER_NOTIFICATION_SETTINGS_INSTALL_SLACK =
  'hirer_notification-settings_install-slack';
export const HIRER_NOTIFICATION_SETTINGS_REMOVE_SLACK = 'hirer_notification-settings_remove-slack';
export const HIRER_NOTIFICATION_SETTINGS_TOGGLE_FIRST_SUBMISSION =
  'hirer_notification-settings_toggle-first-submission';
export const HIRER_NOTIFICATION_SETTINGS_TOGGLE_SUMMARY =
  'hirer_notification-settings_toggle-summary';
export const HIRER_NOTIFICATION_SETTINGS_SELECT_SLACK = 'hirer_notification-settings_select-slack';
export const HIRER_NOTIFICATION_SETTINGS_SELECT_EMAIL = 'hirer_notification-settings_select-email';
export const HIRER_CANDIDATEHUB_HIGHLIGHT_ANSWER = 'hirer_candidatehub_highlight-answer';
export const HIRER_CANDIDATEHUB_RATE_QUESTION = 'hirer_candidatehub_rate-question';
export const HIRER_CANDIDATEHUB_ONBOARDING_REPORT_VIEW =
  'hirer_candidatehub_onboarding-report-view';
export const HIRER_CANDIDATEHUB_FRAMEWORK_VIEW = 'hirer_candidatehub_framework-view';

export const HIRER_CANDIDATEHUB_SELF_ASSESSMENT_VIEW = 'hirer_candidatehub_self-assessment-view';

export const HIRER_CANDIDATEHUB_SELF_ASSESSMENT_COMPARISON_VIEW =
  'hirer_candidatehub_self-assessment-comparison-view';

/* Anonymous events */
export const USER_EVENT_TYPE = 'User';

export const USER_PUBLIC_PROFILE_VIEW = 'user_public-profile_view';
export const USER_PUBLIC_PROFILE_CLICK_REQUEST_REPORT = 'user_public-profile_click-request-report';
export const USER_PUBLIC_PROFILE_SUBMIT_REQUEST_REPORT =
  'user_public-profile_submit-request-report';
export const USER_PUBLIC_PROFILE_COPY_PUBLIC_URL = 'user_public-profile_copy-public-url';
export const USER_PUBLIC_PROFILE_GROWTH_BANNER_CLICK_GUIDE =
  'user_public-profile_growth-banner_click-guide';
export const USER_PUBLIC_PROFILE_GROWTH_BANNER_CLICK_DEMO =
  'user_public-profile_growth-banner_click-demo';

export const HIRER_LOGIN_CLICK_OKTA_SSO = 'hirer_login_click-okta-sso';

export const HIRER_LOGIN_COMPLETE_OKTA_SSO = 'hirer_login_complete-okta-sso';

export const HIRER_COMPANY_COMMS_EDIT_EMAIL_SUBJECT = 'hirer_company-comms_edit-email-subject';

export const HIRER_COMPANY_COMMS_EDIT_BODY_TEXT = 'hirer_company-comms_edit-body-text';

export const HIRER_COMPANY_COMMS_SEND_TEST = 'hirer_company-comms_send-test';

export const HIRER_DEVELOPER_API_SHOW_KEY = 'hirer_developer-api_show-key';

export const HIRER_DEVELOPER_API_REGENERATE_KEY = 'hirer_developer-api_regenerate-key';

export const HIRER_DEVELOPER_API_DELETE_KEY = 'hirer_developer-api_delete-key';

export const HIRER_GENERAL_SETTINGS_CLICK_CONNECT_HRIS =
  'hirer_general-settings_click-connect-hris';

export const HIRER_CANDIDATE_HUB_VIEW_SELF_ASSESSMENT = 'hirer_candidate-hub_view-self-assessment';

export const HIRER_CANDIDATE_HUB_VIEW_INTAKE_MATCH = 'hirer_candidate-hub_view-intake-match';

export const HIRER_SURVEYS_START_CUSTOMIZE_FORM = 'hirer_surveys_start-customize-form ';

export const HIRER_SURVEYS_SUBMIT_CUSTOMIZE_FORM = 'hirer_surveys_submit-customize-form ';

export const HIRER_TEAMS_CREATE = 'hirer_teams_create';

export const HIRER_TEAMS_EDIT = 'hirer_teams_edit';
